<script setup>
const props = defineProps(["label", "required", "checked", "disabled", "modelValue", "error"]);
const emit = defineEmits(["update:modelValue"]);
</script>

<template>
	<div class="paragraph md">
		<input id="checkbox" type="checkbox" class="checkbox" :required="required" :disabled="disabled" :checked="modelValue" @input="$emit('update:modelValue', $event.target.checked)" />
		<label for="checkbox">
			<span class="select-none opacity-70">{{ label }}</span>
		</label>
		<p class="pt-2 text-xs" v-if="error">{{ error }}</p>
	</div>
</template>

<style scoped>
input[type="checkbox"] {
	@apply hidden;
}

label {
	@apply relative flex cursor-pointer items-center gap-3 bg-neutral-700;
}

label::before {
	@apply block h-5 w-5 rounded-big border border-border-default bg-bg transition-all content-[''];
}

input:checked + label::before {
	@apply border-default bg-default;
}

input:checked + label::after {
	@apply absolute left-2 top-1.5 h-3 w-1.5 rotate-45 border-border-default content-[''];
	border-width: 0 2px 2px 0;
}

label::before:hover {
	@apply border-paper-darker;
}
</style>
